/** @format */

import React from "react";

//market and profile pages
import ErrorRoute from "../../router/error-route";
import EmpIndex from "../../views/dashboard/emp_index";
import EmpProfile from "../../views/dashboard/profiles/emp-profile/my-profile/my-profile";
import JobPosting from "../../views/dashboard/profiles/emp-profile/job-list/job-posting";
import EmpDashboard from "../../views/dashboard/app/dashboard/emp_dashboard";
import Candidate from "../../views/dashboard/app/candidate_list/candidate";
import EmpSetting from "../../views/dashboard/app/settings/settings";
import CreateEmpProfile from "../../views/dashboard/profiles/emp-profile/my-profile/create-profile";
import JobListing from "../../views/dashboard/profiles/emp-profile/job-list/job-listing";

export const EmpProtectedRouter = [
  {
    key: "index",
    path: "/e",
    element: <EmpIndex />,
  },
  {
    key: "error",
    path: "*",
    element: <ErrorRoute />,
  },
  {
    key: "emp-profile",
    path: "/e/myprofile",
    element: <EmpProfile />,
  },
  {
    key: "create-emp-profile",
    path: "/e/create-profile",
    element: <CreateEmpProfile />,
  },
  {
    key: "job-posting",
    path: "/e/job-posting",
    element: <JobPosting />,
  },
  {
    key: "emp-dashboard",
    path: "/e/dashboard",
    element: <EmpDashboard />,
  },
  {
    key: "emp-jobposting",
    path: "/e/jobposting",
    element: <JobPosting />,
  },
  {
    key: "emp-joblisting",
    path: "/e/joblisting",
    element: <JobListing />,
  },
  {
    key: "emp-setting",
    path: "/e/setting",
    element: <EmpSetting />,
  },
  {
    key: "candidate-listing",
    path: "/e/candidate",
    element: <Candidate />,
  },
];
